import { connect } from 'react-redux';
import React, { Component, PropTypes } from 'react';
import moment from 'moment'
import UserProfile from '../../components/patient/UserProfile';
import {InputField, DateField, SelectField, MultiplePhoneField} from '../../commons/Inputs';
import appConfig from '../../../config';
import axios from 'axios';

import {
    getSessionApi
} from '../../actions/session';

let $ = window.jQuery;
let App = window.App;

class Profile extends Component {
    static propTypes = {
        getSessionApi: PropTypes.func.isRequired,
        session: PropTypes.object.isRequired
    };

    state = {
        'user': '',
        data : {user : {media_id : 0}},
        id: '',
        firstname: '',
        middlename: '',
        lastname: '',
        gender: '',
        birthdate: '',
        prc: '',
        ptr: '',
        s2_license: '',
        media_id : 0,
        civil_status : '',
        phone_numbers: [{
            'number':'',
            'phone_type_id': 1
        }],
        currentPassword: '',
        newPassword: '',
        verifyPassword: ''

    };

    handlePhones = (e) => {
        // e.preventDefault();
        let element = $(e.target);

        if(element.hasClass('addPhone')) {
            if(element.parents('.perContainer').find('.phoneInput').val().trim() === '') {
                element.parents('.perContainer').find('.phoneInput').focus();
                return false;
            }

            element.attr('class',' fa fa-times removePhone');

            let phoneInputs = {
                'number': '',
                'phone_type_id': 1
            };
            let phone_numbers = this.state.phone_numbers;
            phone_numbers.push(phoneInputs);

            this.setState({
                phone_numbers
            });

        } else if(element.hasClass('removePhone')) {
            let index = element.parents('.perContainer')[0].dataset.index;

            let phone_numbers = this.state.phone_numbers;
            phone_numbers.splice(index, 1);

            this.setState({
                phone_numbers
            })
        }
    };

    updatePhoneArray = (index, number, phone_type_id) => {
        let phone_numbers = this.state.phone_numbers;
        phone_numbers[index] = {
            number, phone_type_id
        };

        this.setState({
            phone_numbers : phone_numbers
        });
    };

    handleSaveProfile = (e) => {

        let url = appConfig.apiUrl + 'tenant';
        let formData = $('#myProfileForm').serializeArray();
        formData.push({name:'id', value: this.state.id});
        formData.push({name:'birthdate', value: moment(this.state.birthdate, 'MMM DD, YYYY').format('YYYY-MM-DD')});
        // console.log(formData);

        /*update picture*/ //for sessionStorage
        // let user = this.props.session.get('user').toJS();
        // let sessionUser = JSON.parse(sessionStorage.getItem('user'));
        //
        // if($('#media_id').val() !== '')
        // {
        //     sessionUser.user_info.media_id = $('#media_id').val();
        //     let image = appConfig.staticFiles + $('#media_id').val();
        //     $('.tenantProfilePic').css("background-image","url("+image+")");
        // }
        // sessionUser.user_info.firstname = this.state.firstname;
        // sessionUser.user_info.lastname = this.state.lastname;
        // sessionStorage.setItem('user',JSON.stringify(sessionUser));

        // eslint-disable-next-line
        // if (sessionUser.user_info.user_type_id == 3) {
        //     $('#headerProfileName').html(this.state.firstname + ' ' + this.state.lastname);
        // } else {
        //     $('#headerProfileName').html('Dr. ' + this.state.firstname + ' ' + this.state.lastname);
        // }


        axios({
            url: url,
            timeout: 20000,
            method: 'post',
            data: window.jQuery.param(formData)
        }).then((res) => {
            $('#media_id').val('');
            this.setState({
                data: res.data.data
            });

            this.showSuccessNotification();
            this.props.getSessionApi();
        }).catch((error) => {
            console.log(error);
        });
    };

    handleChangePassword = (e) => {
        let url = `${appConfig.apiUrl}accounts/change-password`;
        let data = {
            current_password: this.state.currentPassword,
            new_password: this.state.newPassword,
            verify_password: this.state.verifyPassword
        };

        axios.put(url, data).then((res) => {
            console.log(res);
            this.props.showNotification('success', 'Password Changed!');
        }).catch((error) => {
            let message = error.response.data.errors[0];
            console.log(message);
            this.props.showNotification('error', message);
        });
    };

    showSuccessNotification = () => {
        // let notificationSystem = this.refs.notificationSystem;

        // notificationSystem.addNotification({
        //     title: 'Saved! Successfully',
        //     message: 'Patient Successfully Saved!',
        //     level: 'success',
        //     position : 'br',
        //     autoDismiss : 1
        // });

        App.alert({
            type: 'info',
            container : $('#myProfileAlertNotif'),
            message: 'Saved Succesfully!',
            reset: true,
            focus: false,
            close: false,
            closeInSeconds: 1})
    };

    componentWillMount() {
        if (! this.props.session.get('user')) {
            this.props.getSessionApi();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.session.get('user')) {
            let user = nextProps.session.get('user').toJS();
            let userInfo = user.user_info;
            let roleInfo = user.role_info;

            if (userInfo.role === 'dentist' || userInfo.role === 'practitioner') {

                this.setState({
                    data: {user: userInfo},
                    id: userInfo.id,
                    media_id: userInfo.media_id,
                    firstname: userInfo.firstname,
                    middlename: userInfo.middlename,
                    lastname: userInfo.lastname,
                    birthdate: userInfo.birthdate,
                    gender: userInfo.gender,
                    civil_status: userInfo.civil_status ? userInfo.civil_status : '',
                    prc: roleInfo.prc,
                    ptr: roleInfo.ptr,
                    s2_license: roleInfo.s2_license,
                    phone_numbers: userInfo.user_phone_numbers.length > 0 ? userInfo.user_phone_numbers : [{'number':'', 'phone_type_id': ''}]
                });
            } else {
                this.setState({
                    data: {user: userInfo},
                    id: userInfo.id,
                    media_id: userInfo.media_id,
                    firstname: userInfo.firstname,
                    middlename: userInfo.middlename,
                    lastname: userInfo.lastname,
                    birthdate: userInfo.birthdate,
                    gender: userInfo.gender,
                    civil_status: userInfo.civil_status ? userInfo.civil_status : '',
                    phone_numbers: userInfo.user_phone_numbers.length > 0 ? userInfo.user_phone_numbers : [{'number':'', 'phone_type_id': ''}]
                })
            }
        }
    }

    render() {
        var genderOptions = [
            { value: 1, label: 'Male'},
            { value: 0, label: 'Female'},
        ];
        var birthdate = moment(this.state.birthdate).format('MMMM DD, YYYY');

        return(
            <div className="page-content">
                <h3 className="page-title">
                    PROFILE ACCOUNT
                </h3>
                <div className="row">
                    <div className="col-md-12">


                        <UserProfile data={this.state.data} scrollState="profile" onMediaChoice={this.handleSaveProfile} />

                        <div className="profile-content">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="portlet light" style={{padding: '53px'}}>

                                        <div id="myProfileAlertNotif"></div>

                                        <div className="portlet-title tabbable-line">
                                            <ul className="nav nav-tabs nav-justified" id="menuTabsLinks">
                                                <li className='active'>
                                                    <a href="#profileInfo" data-toggle="tab">Profile</a>
                                                </li>

                                                <li>
                                                    <a href="#changePassword" data-toggle="tab">Change Password</a>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="portlet-body">
                                            <div className="tab-content">
                                                <div className="tab-pane active" id="profileInfo">
                                                    <form id="myProfileForm">
                                                        <input type="hidden" name="media_id" id="media_id" />
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <InputField val={this.state.firstname} id="firstname" label="First Name" help="" onChange={(e) => {this.setState({firstname : e.target.value})}} />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <InputField val={this.state.middlename} id="middlename" label="Middle Name" help="" onChange={(e) => {this.setState({middlename : e.target.value})}} />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <InputField val={this.state.lastname} id="lastname" label="Last Name" help="" onChange={(e) => {this.setState({lastname : e.target.value})}} />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <DateField onChange={(e) => {this.setState({birthdate: e.target.value})}} val={birthdate} id="birthdate" label="Birth Date" help="" />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <SelectField val={this.state.gender} id="gender" label="Gender" help="" options={genderOptions} onChange={(e) => {}}/>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group form-md-line-input">
                                                                    <select className="form-control" name="civil_status" value={this.state.civil_status}  onChange={(e) => {this.setState({civil_status : e.target.value}) }}>
                                                                        <option value="">Select...</option>
                                                                        <option value="single">Single</option>
                                                                        <option value="married">Married</option>
                                                                        <option value="separated">Separated</option>
                                                                        <option value="widowed">Widowed</option>
                                                                    </select>
                                                                    <label className="control-label">Civil Status</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <InputField val={this.state.prc} id="prc" label="License Number" help="" onChange={(e) => {this.setState({prc : e.target.value})}} />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <InputField val={this.state.ptr} id="ptr" label="PTR Number" help="" onChange={(e) => {this.setState({ptr : e.target.value})}} />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <InputField val={this.state.s2_license} id="s2_license" label="S2 License Number" help="" onChange={(e) => {this.setState({s2_license : e.target.value})}} />
                                                            </div>
                                                        </div>
                                                        {/*<InputField val="" id="email" label="Email Address" help="" />*/}
                                                        <div className="row">
                                                            <div className="col-md-8">
                                                                <div className="parent_content" onClick={this.handlePhones}>
                                                                    {this.state.phone_numbers.map((phone, i) => {

                                                                        phone.number = phone.number.replace(' ', '').replace('(','').replace(')','').replace('-','');

                                                                        return <MultiplePhoneField key={i} index={i} totalIndex={this.state.phone_numbers.length}
                                                                                                   val={phone.number} phoneType={phone.phone_number_type_id}
                                                                                                   numberId={"phone_numbers[" +i+ "][number]"} typeId={"phone_numbers[" +i+ "][type]"} label="Number" help="Phone" type="text"
                                                                                                   updatePhoneArray={this.updatePhoneArray} />
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-group text-right">
                                                            <button type="button" className="btn blue" onClick={this.handleSaveProfile}>Save</button>
                                                        </div>
                                                    </form>
                                                </div>

                                                <div className="tab-pane" id="changePassword">
                                                    <form id="changePassword">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <InputField val={this.state.currentPassword} help=""
                                                                            type="password"
                                                                            id="currentPassword" label="Current Password"
                                                                            onChange={(e) => {this.setState({currentPassword : e.target.value})}} />
                                                            </div>
                                                            <div className="col-md-12">
                                                                <InputField val={this.state.newPassword} help=""
                                                                            type="password"
                                                                            id="newPassword" label="New Password"
                                                                            onChange={(e) => {this.setState({newPassword : e.target.value})}} />
                                                            </div>
                                                            <div className="col-md-12">
                                                                <InputField val={this.state.verifyPassword} help=""
                                                                            type="password"
                                                                            id="verifyPassword" label="Verify Password"
                                                                            onChange={(e) => {this.setState({verifyPassword : e.target.value})}} />
                                                            </div>
                                                        </div>

                                                        <div className="form-group text-right">
                                                            <button type="button" className="btn blue" onClick={this.handleChangePassword}>Save</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        session: state.session
    }
};

export default connect(mapStateToProps, {
    getSessionApi
})(Profile);


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/index.js
 **/